import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as capitalProjectInterest from '../../capital-project-interest'

export const RESOURCE = {
  payload: {
    description:
      'A financial record tracking interest expenses related to capital projects.',
    dimension: capitalProjectInterest.RESOURCE.payload,
    level: 0,
    name: 'Capital Project Interest Entry',
    partialId: PartialId.Standard.create('entry'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
